export enum PaginationDefinition {
	PAGE_SIZE = 20,
	DEFAULT_PAGE_NUMBER = 1,
	PAGE_TWO = 'page-2',
	PAGE_THREE = '?page=3'
}
